// test151
(151 && 0);
